<template>
  <div class="my" >
    <div class="left-box">
        <div class="break-box" >
            <div class="break">
                <i class="el-icon-back" @click="$router.go(-1)"></i>
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">HOME</el-breadcrumb-item>
                    <el-breadcrumb-item>
                        <span style="cursor:default;font-weight: 600;color:#09CA6A;font-size: 16px;">My account</span>
                    </el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="profile-box" >
            <img src="@assets/images/profile_default.png" alt="">
        </div>
        <h3 class="user-name" >{{ userName }}</h3>
        <h4 class="user-email" >{{ userInfo.emailAddress }}</h4>
        <div class="tab-box "></div>
    </div>

    <div class="right-box">

    </div>
    
   
  </div>
</template>

<script>
import debounce from "@/utils/debounce.js";
import { postGateway } from '@/request';
export default {
  name: "NotFound",
  metaInfo: {
    meta: ["All Eat "],
    title: "All Eat not found",
  },
  data() {
    return {
      transType: 1,
      keywords: "",
      resultList: [],
      loading: false,
      clientId: null,
      userInfo: {
        contactPhone: '',
        emailAddress: '',
        firstName: '',
        lastName: '',
        mobilePhone: '',
        nickName: '',
      }
    };
  },
  components: {
  },
  created() {
    this.clientId = localStorage.getItem('clientId');
    this.getUserInfo();
  },
  mounted() {

  },
  computed: {
    userName() {
        return this.userInfo.nickName || this.userInfo.firstName + this.userInfo.lastName || 'AllEat User'
    }
  },
  methods: {
    getUserInfo() {
        postGateway({
            url: `/customerApp/center/getDetail`,
            method: 'GET',
            data: {
                clientId: this.clientId
            }
        }).then(res=>{
            this.userInfo = res.data;
            console.log(res,'用户信息')
        })
        .catch(err=>{
            console.log(err)
        })
    },
    inputNow() {
      this.resultList = [];
      this.loading = true;
      debounce(() => {
        if (this.keywords.trim().length < 3) return;
        this.$postGateway({
          method: "GET",
          url: "/customerApp/index/getPreKeyword",
          data: { keyword: this.keywords },
        })
          .then((res) => {
            console.log(res)
          })
          .catch(() => {
            
          });
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
.my {
  min-height: calc(100vh - 96px);
  display: flex;
  padding: 30px 4% 30px;

  .left-box {
    width: 30%;
    min-width: 300px;
    display: flex;
    flex-direction: column;
    border: 1px solid black;
    margin-right: 20px;
    padding: 0;

    .break-box {
        box-sizing: border-box;
        padding: 10px 4%;
        .break {
            height: 380px;
            height: 44px;
            display: inline-flex;
            align-items: center;
            padding: 20px;
            border-radius: 22px;
            background-color: #0A191E;
            color: #FFFFFF;
            .el-icon-back {
                color: #2680ED;
                font-size: 22px;
                margin-right: 10px;
            }
            :deep(.el-breadcrumb__inner) {
                color: #fff;
            }
            :deep(.el-breadcrumb__separator) {
                color: #fff;
            }
        }
    }

    .profile-box {
        height: 150px;
        width: 150px;
        border-radius: 75px;
        overflow: hidden;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        margin: 20px auto 0;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
            height: 144px;
            width: 144px;
            border-radius: 77px;
        }
    }
    .user-name {
        height: 30px;
        font-size: 30px;
        text-align: center;
        color: #000;
        margin: 8px 0;
        font-weight: 400;
    }
    .user-email {
        height: 25px;
        color: #000;
        font-size: 20px;
        text-align: center;
        margin: 0px;
    }

    .tab-box {
        margin: 32px 10px 0;
        height: 400px;
        background: #FFFFFF;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        border-radius: 10px;
    }

  }

  .right-box {
    flex: 1;
    min-width: 600px;
    border: 1px solid black;
  }

  .back-btn {
    position: relative;
    background: #fff;
    height: 36px;
    border-radius: 18px;
    padding: 0 20px;
    font-weight: bold;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin: 30px 6% 0;
  }
}
</style>
